import { Link } from 'react-router-dom';

const latestArticles = [
  {
    slug: 'zhengtu-xinshou-gonglve-2026',
    title: '征途国际2026新手入门完全攻略',
    categoryName: '游戏攻略',
    excerpt: '刚踏入征途国际的世界不知从何下手？本篇攻略从职业选择、升级路线到装备获取，手把手带你快速成长为一方霸主。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20warrior%20holding%20a%20glowing%20sword%20on%20a%20battlefield%20at%20sunset%2C%20epic%20fantasy%20game%20art%20style%2C%20dramatic%20lighting%2C%20golden%20and%20crimson%20tones%2C%20atmospheric%20mist%2C%20heroic%20pose%2C%20cinematic%20composition&width=800&height=400&seq=article-card-xinshou&orientation=landscape',
    date: '2026-08-10',
    readTime: '8分钟',
  },
  {
    slug: 'zhengtu-zhiye-xuanze-zhinan',
    title: '征途国际六大职业深度解析与选择指南',
    categoryName: '游戏攻略',
    excerpt: '战士、法师、弓手、仙术、刺客、召唤六大职业各有千秋。本文深度解析各职业技能特点、PVP与PVE表现，帮你找到最适合的职业。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Six%20different%20ancient%20Chinese%20warrior%20classes%20standing%20in%20formation%2C%20each%20with%20unique%20weapons%20and%20armor%2C%20epic%20fantasy%20illustration%2C%20rich%20warm%20color%20palette%2C%20cinematic%20lighting&width=800&height=400&seq=article-card-zhiye&orientation=landscape',
    date: '2026-08-05',
    readTime: '12分钟',
  },
  {
    slug: 'zhengtu-v860-gengxin-gonggao',
    title: '征途国际v8.6.0版本更新公告：全新跨服战场来袭',
    categoryName: '版本更新',
    excerpt: '征途国际v8.6.0版本正式上线！全新跨服战场、装备觉醒系统、帮会联赛等重磅内容全面开放，赶快更新体验吧！',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20battlefield%20with%20thousands%20of%20warriors%20clashing%2C%20epic%20scale%2C%20dramatic%20golden%20and%20red%20color%20scheme%2C%20cinematic%20game%20art%2C%20flying%20banners%20and%20flags&width=800&height=400&seq=article-card-gengxin&orientation=landscape',
    date: '2026-08-10',
    readTime: '5分钟',
  },
];

export default function LatestArticles() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
              征途攻略
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
              最新资讯与攻略
            </h2>
          </div>
          <Link
            to="/category/strategy"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-2xl bg-background-100 overflow-hidden hover:bg-background-200/70 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  <strong>{article.title}</strong>
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/strategy"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}